module.exports = __webpack_public_path__ + "media/vr-video.25847833.mp4";